import { Icon } from "./Icon.tsx";

/** "Selection tools" menu trigger icon — a pointer arrow (the generic "select" tool glyph), distinct from the specific rectangle/lasso/multi icons this menu opens onto. */
export function SelectionToolsIcon() {
  return (
    <Icon>
      <path d="M5 3l6.5 16 2-6.5L20 10.5Z" />
    </Icon>
  );
}
